import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable @repo/internal/react/no-class-components */
import React from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var analyticsEvent = this.props.createAnalyticsEvent({
        action: 'handled',
        actionSubject: 'error',
        actionSubjectId: 'remoteModuleErrorBoundary',
        attributes: {
          error: error === null || error === void 0 ? void 0 : error.message,
          errorInfo: errorInfo,
          dimensions: this.props.remotePlugin.dimensions,
          plugin: this.props.remotePlugin.constructor.name
        }
      });
      analyticsEvent.fire(this.props.analyticsChannel);
      this.setState({
        hasError: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return this.props.fallback ? /*#__PURE__*/React.createElement(React.Fragment, null, this.props.fallback) : null;
      }
      return this.props.children;
    }
  }]);
  return ErrorBoundary;
}(React.Component);
export default withAnalyticsEvents()(ErrorBoundary);